import React, { useState } from 'react'

// evertel
import { DisplayRoomMessage } from '@evertel/stores'
import { Col, Icon, Row, Text } from '@evertel/web/ui'
import { ProfilePic } from '@evertel/web/user'
import { useService } from '@evertel/di'
import { RoomForwardedMessageController } from '@evertel/room'
import { parsedContent } from '../../../../utils/message'
import { ReplyTileBodyProps } from './ReplyTileBody'
import { MessageHeader } from '../MessageHeader'
import { ReplyTileBodyUser } from './ReplyTileBodyUser'


const ReplyTileBodyForwarded: React.FC<ReplyTileBodyProps> = ({
    message,
    media
}) => {
    const roomForwardedMessageController = useService(RoomForwardedMessageController, [message])

    useState(() => {
        roomForwardedMessageController.init(message)
    })

    const truncatedMessage = message.text.length > 250 ? message.text.slice(0, 250) + '...' : message.text

    const forwardedPost = roomForwardedMessageController.message as DisplayRoomMessage
    const room = roomForwardedMessageController.room
    const user = roomForwardedMessageController.user || {}
    const formattedDate = roomForwardedMessageController.formattedPublished

    return (
        <Col className="mt-1">
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {message.isUrgent && (
                    <span className="urgent-icon">
                        <Icon
                            name="triangle-exclamation"
                        />
                    </span>
                )}

                <div
                    dangerouslySetInnerHTML={{ __html: parsedContent(truncatedMessage) }}
                    className={`post-content reply-body ${message.isUrgent ? 'urgent' : ''}`}
                    style={{ display: 'inline-block' }}
                />
            </div>
            <div className="reply-forwarded-item">
                <Row>
                    <Col valign="top" className="left-col ms-2">
                        <ProfilePic
                            userId={user?.id}
                            isGuest={false}
                            width={20}
                            height={20}
                        />
                    </Col>
                    <Col xs={11} valign="top" className="ms-1">
                        <MessageHeader
                            message={forwardedPost}
                            user={user}
                            isGuest={false}
                            className="reply-body"
                            variant="reply-forwarded"
                        />
                    </Col>
                </Row>
                <Row className="ms-2 mt-2">
                    <ReplyTileBodyUser
                        message={forwardedPost}
                        media={media}
                        variant="forward"
                    />
                </Row>
                <div className="ms-2 mt-2">
                    <Text size="smaller" bold className="mt-4">
                        {room?.name &&
                            <Text color="body-color" className="mt-4">
                                {forwardedPost?.repliesToId ? 'Reply in #' : 'Posted in #'}{`${room?.name} | ${formattedDate}`}
                            </Text>
                        }
                    </Text>
                </div>
            </div>
        </Col>
    )
}

export { ReplyTileBodyForwarded}
